export const ExternalHost = 'http://47.98.227.0';